<template>
  <div class="layout1" style="background: #f4f6f8">
    <!-- <div class="intes-ts">
      报告对比
      <van-icon name="arrow" />
    </div> -->

    <van-tabs
      v-model="activeName"
      class="vantabs mytabs"
      animated
      @click="onClick"
      color="#2E94E5"
      line-height="3px"
      line-width="60px"
      title-active-color="#2E94E5"
    >
      <van-tab
        v-for="item in navData"
        :key="item.name"
        :title="item.name"
        :name="item.name"
      >
        <component v-if="item.show" :is="item.url" :list="item"></component>
      </van-tab>
    </van-tabs>

    <ball :text="'返回'"></ball>
  </div>
</template>
<script>
import pointDetail from "./components/pointDetail.vue"
import reportDetail from "./components/reportDetail.vue"
import ball from "./components/ball.vue"
export default {
  components: { pointDetail, ball, reportDetail },
  data () {
    return {
      activeName: '',
      navData: [
      ],
    }
  },
  created () {
    window.scrollTo(0, 0);
    this.activeName = this.$route.query.item
    this.navData = JSON.parse(this.$route.query.list)
    this.navData.forEach((item) => {
      item.url = 'pointDetail',
        item.show = true
    })
  },
  methods: {
    onClick (name, title) {
      this.$route.query.item = title
      console.log(this.$route.query.item);
    },
  }
}
</script>
<style lang="scss" >
.layout1 {
  .van-tabs__content--animated {
    padding-top: 0;
  }
}
// .intes-bg {
//   background: #ffffff;
// }
// .intes-ts {
//   height: 50px;
//   display: flex;
//   /*实现垂直居中*/
//   align-items: center;
//   justify-content: space-between;
//   color: #e28c3f;
//   font-size: 22px;
//   padding: 0 20px;
//   text-align: left;
//   background: #ffe8b8;
//   border-radius: 4px;
// }

.mytabs {
  width: 100%;
  margin-top: 20px;
  padding: 0 20px 20px 20px;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0px 10px 29px 0px rgba(91, 145, 190, 0.1);
  border-radius: 10px;
  box-sizing: border-box;
  overflow: hidden;
  font-size: 14px;
  .van-tabs__nav,
  .van-tabs--line .van-tabs__wrap {
    background: none;
  }
  .van-tabs__wrap--scrollable .van-tab {
    padding: 0 1px;
    flex: 0 0 20% !important;
  }
}
.pointList {
  .van-cell {
    padding: 40px 20px;
    font-size: 26px;
  }
}
</style>